import { Component, Input, OnInit } from '@angular/core';
import { AnnouncementExtendedLocationViewModel } from '@hrra/common-models';

@Component({
    selector: 'hrra-announcement-location',
    templateUrl: './announcement-location.component.html',
    styleUrls: ['./announcement-location.component.scss'],
    standalone: false
})
export class AnnouncementLocationComponent implements OnInit {

  @Input() locations: AnnouncementExtendedLocationViewModel[];

  constructor() { }

  ngOnInit(): void {
  }

}
